import { removeFromStorage } from './webStorage';

/** Clears stored auth credentials and related session keys. */
export const clearAuthSession = (): void => {
    removeFromStorage('accessToken');
    removeFromStorage('refreshToken');
    removeFromStorage('roles');
    removeFromStorage('role');
    removeFromStorage('user');
    removeFromStorage('cgToken');
};

export const getAuthUsernameParam = (): string | null => {
    if (typeof window === 'undefined') return null;
    const username = new URLSearchParams(window.location.search)
        .get('username')
        ?.trim();
    return username || null;
};

export const isAuthRouteWithUsernameParam = (): boolean => {
    if (typeof window === 'undefined') return false;
    const onAuthRoute =
        window.location.pathname === '/auth' ||
        window.location.pathname.startsWith('/auth/');
    return onAuthRoute && Boolean(getAuthUsernameParam());
};
